import React from "react";
import  './Resources/Actions.css';
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';

export default function User(){
    const navigate = useNavigate();
    const user = localStorage.getItem("utype");
    const APP_NAME = process.env.REACT_APP_NAME;

    return(
        <>
       
       <div style = {{height:"100%", width:"100%"}}>
            <div className="reportheader">{APP_NAME} </div>
            <div className="subheader">User Details </div>
            <Navbar/>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/createuser')}}>Create User</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/modifyuser')}}>Modify User</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/userloan')}}>Approval / Opening Balance</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/userloantopup')}}>Balance Add-On</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/deleteuserloan')}}>Delete Approval</div>
        </div>
        <button type="button" className="backbutton" onClick={()=>{navigate('/home')}}>Back</button>
        </>)
}